export const booleanCellLabels = { true: "True", false: "False" };

export function setBooleanCellLabels(trueLabel: string, falseLabel: string): void {
  booleanCellLabels.true = trueLabel;
  booleanCellLabels.false = falseLabel;
}
